import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { ToastContainer } from 'react-toastify';
import ServiceDetails from './components/ServiceDetails';
import ServiceDays from './components/ServiceDays';

const RouterApp = () => {
  return (<>
    <ToastContainer />
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/service/:serviceId" element={<ServiceDetails />} />
        <Route path="/service/:serviceId/:date" element={<ServiceDays />} />
      </Routes>
    </Router></>
  );
};

export default RouterApp;
